import httpClient from "../../../shared/api/httpClient";

// Espelha domain.Category do backend (internal/feedback/domain/feedback.go).
export const CATEGORIAS_FEEDBACK = [
  { value: "suggestion", label: "Sugestão" },
  { value: "problem", label: "Problema" },
  { value: "praise", label: "Elogio" },
];

export const feedbackApi = {
  send: ({ category, message, page }) =>
    httpClient.post("/api/v1/feedbacks", { category, message, page }).then((r) => r.data.dados),
};
